import { render, staticRenderFns } from "./HowToUseMobile.vue?vue&type=template&id=6e21eb76"
import script from "./HowToUseMobile.vue?vue&type=script&lang=js"
export * from "./HowToUseMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports